import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { resetInbox, showLoading } from 'app/inbox/inbox-deliveries/store/inbox.actions';
import { setUnread } from 'app/inbox/sorting-btn/store/delivery-sort.actions';
import { getUnreadValue } from 'app/inbox/sorting-btn/store/delivery-sort.selectors';
import { InboxFilterState } from 'app/inbox/filter/store/filter-inbox.reducer';

@Component({
  standalone: false,
  selector: 'pptl-unread-btn',
  templateUrl: './unread-btn.component.html',
  styleUrls: ['./unread-btn.component.scss'],
})
export class UnreadBtnComponent implements OnInit {
  isUnread = false;

  constructor(private store: Store<InboxFilterState>) {}

  toggleButton(): void {
    this.isUnread = !this.isUnread;
    this.store.dispatch(resetInbox());
    this.store.dispatch(showLoading());
    this.store.dispatch(setUnread({ viewBy: this.isUnread ? 'unread' : 'All' }));
  }

  ngOnInit() {
    this.store.pipe(select(getUnreadValue), take(1)).subscribe((resp: 'All' | 'unread') => {
      this.isUnread = resp === 'unread';
    });
  }
}
